import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "message",
      description: "说明文字",
      type: "String"
    },
    {
      prop: "subMessage",
      description: "次级说明文字",
      type: "String"
    },
    {
      prop: "type",
      description: "主题样式",
      type: "String",
      available: "info/success/error",
      default: "info"
    },
    {
      prop: "duration",
      description: "显示时间, 毫秒。设为 0 则不会自动关闭",
      type: "Number",
      default: "4500"
    },
    {
      prop: "showClose",
      description: "是否显示关闭按钮",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "onClose",
      description: "关闭时的回调函数",
      type: "Function"
    }
  ],
  events: [],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
